import { SearchWindowType } from "src/scripts/typings/WindowType";
import { CookieService } from "./CookieService";
import { updateGtagConsentFromPreferences, updateGtagConsentToAllowAll } from "../gtm/GtagConsent";

export class CookiePolicy {
	private updateGtagConsentToAllowAll = updateGtagConsentToAllowAll;
	private updateGtagConsentFromPreferences = updateGtagConsentFromPreferences;

	private windowHelper = window as SearchWindowType;

	private cookieService: CookieService;
	private document = document;
	private modal = "#js_cookie-banner";
	private activeClass = "active";

	constructor(cookieName: string, cookieDomain: string) {
		this.cookieService = new CookieService(cookieName, cookieDomain);
	}

	// tested
	public Init(): void {
		this.showModal();
		this.setupModalConfig();
	}

	// tested
	public setupModalConfig(): void {
		const modal = this.document.querySelector(this.modal);
		if (modal) {
			this.addCloseBtnEventListener(modal);
			this.addSaveBtnEventListener(modal);
			this.setPreferredModalValues(modal);
		}
	}

	// tested
	public showModal(): void {
		const modal = this.document.querySelector(this.modal);
		(modal as HTMLElement).classList.add(this.activeClass);
	}

	// tested
	public hideModal(): void {
		const modal = this.document.querySelector(this.modal);
		(modal as HTMLElement).classList.remove(this.activeClass);
	}

	// tested
	public addCloseBtnEventListener(modal): void {
		const closeBtn = modal.querySelector("#js_hide-banner");
		if (closeBtn) {
			closeBtn.addEventListener("click", (e) => {
				e.preventDefault();
				this.cookieService.setInitialCookie();
				this.updateGtagConsentToAllowAll(this.windowHelper);
				this.hideModal();
			});
		}
	}

	// tested
	public addSaveBtnEventListener(modal): void {
		const saveBtn = modal.querySelector("#js_save-cookie");
		if (saveBtn) {
			saveBtn.addEventListener("click", (e) => {
				e.preventDefault();
				const performanceValue = modal.querySelector("#performance").checked;
				const personalisationValue = modal.querySelector("#personalisation").checked;
				this.cookieService.setCookieSettings(performanceValue, personalisationValue);
				this.updateGtagConsentFromPreferences(this.windowHelper, performanceValue, personalisationValue);
				this.hideModal();
			});
		}
	}

	// tested
	public setPreferredModalValues(modal): void {
		const setCookieSettings = this.cookieService.getCurrentCookieValue();
		if (!!setCookieSettings) {
			const performance = modal.querySelector("#performance");
			const personalisation = modal.querySelector("#personalisation");
			if (performance) {
				performance.checked = setCookieSettings.performance;
			}
			if (personalisation) {
				personalisation.checked = setCookieSettings.personalisation;
			}
		}
	}
}
